<template>
<div>
    <BreadCrumb class="bread" :breads="['理货任务', '设备列表']"></BreadCrumb>
    <div class="wrap" element-loading-text="加载中">
        <div class="header">
            <span class="nameFt">设备列表</span>
            <router-link :to="{path:'/index/restock'}">
                <el-button class="addCustom" size="small" icon="el-icon-arrow-left">
                    返回列表
                </el-button>
            </router-link>
        </div>
        <div class="submit-form">
            <el-form :model="search" :inline="true" size="small" label-width="80px">
                <div class="submit-form__search">
                    <el-form-item label="商家名称">
                        <el-select v-model="search.under_terminal" @change="changeUnder">
                            <el-option :value="1" label="麦杰思"></el-option>
                            <el-option :value="2" label="轻购云"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="缺货金额">
                        <el-input v-model="search.threshold_price" size="small" placeholder="麦杰思设备有这个条件"></el-input>
                    </el-form-item>

                    <el-form-item label="线路名称" prop="line">
                        <el-input v-model="search.line" readonly @focus="openSimpleFindDialog('line')" suffix-icon="el-icon-search"></el-input>
                    </el-form-item>

                </div>
                <div class="submit-form__operate">
                    <el-form-item>
                        <el-button class="queryBtn" size="small" type="primary" @click="searchForm">查询</el-button>
                        <el-button class="queryBtn" size="small" @click="reset">重置</el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>

        <div class="MainTable">
            <el-table :data='tableList' stripe id="MainTables" style="width: 100%" v-loading="loading" ref="multipleTable" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55">
                </el-table-column>
                <el-table-column label="序号" align="center" type="index" :index="indexMethod"></el-table-column>
                <el-table-column prop="hard_number" label="机器编号" align="center">
                </el-table-column>
                <el-table-column prop="line_name" label="线路名称" align="center">
                </el-table-column>
                <el-table-column prop="point_name" label="点位名称" align="center">
                </el-table-column>
                <el-table-column prop="terminal_number" label="设备编号" align="center">
                </el-table-column>
                <el-table-column prop="threshold_price" label="缺货金额" align="center">
                </el-table-column>
                <el-table-column prop="under_terminal" label="商家名称" align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.under_terminal==1" style="color:green">麦杰思</div>
                        <div v-if="scope.row.under_terminal==2" style="color:blue">轻购云</div>
                    </template>

                </el-table-column>
                <el-table-column prop="bin_type" label="设备类型" align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.bin_type==0" style="color:green">单门柜</div>
                        <div v-if="scope.row.bin_type==1" style="color:blue">双门柜</div>
                    </template>

                </el-table-column>

            </el-table>
            <div style="margin-top: 20px; display: flex; justify-content: space-between; align-items: center;">
                <div>已选 {{ multipleSelection.length }} 项 <span style="color:red;font-size:15px;">(注：已选数据请先加入补货单)</span></div>
                <div>
                    <el-button type="primary" size="small" @click="submitSelection">加入补货单</el-button>
                    <el-button type="success" size="small" @click="submitData">查看补货单数据</el-button>
                </div>
            </div>

           <div class="paginationWrap">
                <el-pagination @current-change="handleCurrentChange" :page-size="search.under_terminal ==1 || search.under_terminal==2 || search.threshold_price>0 ?10:20" :current-page="itemsPaging.page_index" layout="total, prev, pager, next" :total="itemsPaging.total_count">
                </el-pagination>
            </div>


        </div>

    </div>
    <simple-find-dialog :show="dialogVisible" :dialogData="dialogData" @close="closeSimpleDialog" :width="'500px'"></simple-find-dialog>
</div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import SimpleFindDialog from "@/components/SimpleFindDialog";
import apis from "@/config/apis";
import {
    download
} from "@/plugins/util";
import listMixin from "@/mixins/list";
export default {
    name: "PointManagement",
    mixins: [listMixin],
    data() {
        return {
            Rem: 1,
            search: {
                page_index: 1,
                page_size: 10,
                under_terminal: '',
                threshold_price: '',
                line_id: "",
                line: "",
            },
            pageSize:"",
            QGList: [],
            MAGEXList: [],
            tableList: [],
            row_id: "",
            showDialog: false,
            removeData: "",
            join: false,
            formData: {
                under_terminal: "",
            },
            dialogData: {},
            dialogVisible: false,

            printVisible: false,
            multipleSelection: [], // 当前页选中的项
            selectedAllList: [], // ✅ 所有页累计的选中项（补货单数据）
            itemsPaging1: {},
            itemsPaging2: {},
            itemsPaging: {},
        };
    },
    created() {
        this.search = Object.assign(this.search, this.$route.query);
        this.getData();
    },
    methods: {
        openSimpleFindDialog(type) {
            switch (type) {
                case "line":
                    this.dialogData = {
                        searchItems: [{
                            key: "name",
                            label: "线路名称",
                        }, ],
                        searchTableItem: [{
                            key: "name",
                            name: "线路名称",
                        }, ],
                        proxyLink: "terminal_line",
                        proxyType: "get",
                    };
                    break;
            }
            this.nowDialogType = type;
            this.dialogVisible = true;
        },
        changeUnder(val){
            console.log(val,'val')

        },
        //关闭上侧选择
        closeSimpleDialog(data) {
            if (data) {
                switch (this.nowDialogType) {
                    case "line":
                        this.search.line = data.name;
                        this.search.line_id = data.id;
                        break;
                }
            }
            this.dialogVisible = false;
        },

        handleSelectionChange(val) {
            // 当前页选中项
            this.multipleSelection = val;

            // 更新全局已选列表（防止跨页丢失）
            val.forEach(item => {
                const exists = this.selectedAllList.some(sel => sel.hard_number === item.hard_number);
                if (!exists) this.selectedAllList.push(item);
            });

            // 去重（防止重复 push）
            this.selectedAllList = this.selectedAllList.filter(
                (v, i, arr) => arr.findIndex(t => t.hard_number === v.hard_number) === i
            );
        },
        toggleAll() {
            if (this.multipleSelection.length === this.tableList.length) {
                this.$refs.multipleTable.clearSelection()
            } else {
                this.tableList.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row, true)
                })
            }
        },
        // 判断该行是否可编辑
        isEditable(row) {
            // 只有选中一个时允许修改，且该行 id 与选中项相同
            return (
                this.multipleSelection.length === 1 &&
                this.multipleSelection[0].hard_number === row.hard_number
            );
        },


        // ✅ 点击生成补货单按钮
        submitSelection() {
            if (!this.multipleSelection.length) {
                this.$message.warning("请先选择数据");
                return;
            }

            // 保存数据到本地存储
            const stored = JSON.parse(localStorage.getItem("replenish_list") || "[]");
            const combined = [...stored];

            this.multipleSelection.forEach(item => {
                if (!combined.some(x => x.hard_number === item.hard_number)) {
                    combined.push(item);
                }
            });

            localStorage.setItem("replenish_list", JSON.stringify(combined));
            this.join = true;
            this.$message.success("已加入补货单");

        },
        submitData() {
            this.$router.push({
                name: "restocked"
            })
        },
        openAdd() {
            this.$router.push({
                name: 'deviceList'
            })
        },

        searchForm() {
            this.search.page_index = 1;
            this.getData();
            // this.getData1();
        },

        async getData() {
            try {
                this.loading = true;
                const page_index = this.search.page_index;
                const page_size = this.search.page_size;

                // 从 search 取出三个关键条件
                const threshold_price = this.search.threshold_price;
                const line_id = this.search.line_id;
                const chosenMerchant = this.search.under_terminal; // 用户在界面上明确选择的商家（可能为 1/2 或 undefined / ''）

                const hasFuzzy = (threshold_price && threshold_price !== '') || (line_id && line_id !== '');

                // ---------- 情况 A: 用户明确选择了商家（1 或 2） ----------
                if (chosenMerchant === 1 || chosenMerchant === '1' || chosenMerchant === 2 || chosenMerchant === '2') {
                    const params = {
                        page_index,
                        page_size,
                        under_terminal: Number(chosenMerchant)
                    };
                    // 把模糊条件也附上（如果有）
                    if (hasFuzzy) {
                        if (threshold_price !== undefined) params.threshold_price = threshold_price;
                        if (line_id !== undefined) params.line_id = line_id;
                    }

                    const res = await this.$axios.get(apis.terminal_exhibition, {
                        params
                    });
                    this.tableList = res.data.data || [];
                    this.itemsPaging = res.data.pagination || {};
                    this.pageSize = res.data.pagination.page_count || {};
                    this.loading = false;
                    return;
                }

                // ---------- 情况 B: 未选商家 ----------
                // 若有模糊搜索条件 → 只请求 under_terminal = 1（麦杰思）
                if (hasFuzzy) {
                    const params = {
                        page_index,
                        page_size,
                        under_terminal: 1,
                        threshold_price,
                        line_id
                    };
                    const res = await this.$axios.get(apis.terminal_exhibition, {
                        params
                    });
                    this.tableList = res.data.data || [];
                    this.itemsPaging = res.data.pagination || {};
                    this.loading = false;
                    return;
                }

                // ---------- 情况 C: 未选商家且无模糊搜索条件 ----------
                // 并发请求 under_terminal = 1 和 under_terminal = 2，然后合并
                const [res1, res2] = await Promise.all([
                    this.$axios.get(apis.terminal_exhibition, {
                        params: {
                            page_index,
                            page_size,
                            under_terminal: 1
                        }
                    }),
                    this.$axios.get(apis.terminal_exhibition, {
                        params: {
                            page_index,
                            page_size,
                            under_terminal: 2
                        }
                    })
                ]);

                const list1 = res1.data.data || [];
                const list2 = res2.data.data || [];
                const pg1 = res1.data.pagination || {};
                const pg2 = res2.data.pagination || {};

                this.tableList = [...list1, ...list2];
                this.itemsPaging = {
                    count: (pg1.count || 0) + (pg2.count || 0),
                    page_count: Math.max(pg1.page_count || 0, pg2.page_count || 0),
                    page_index,
                    total_count: (pg1.total_count || 0) + (pg2.total_count || 0)
                };

                this.loading = false;
            } catch (err) {
                this.loading = false;
                console.error('getData error', err);
            }
        },

        handleCurrentChange(val) {
            this.search.page_index = val;
            this.getData();
        },
        reset() {
            this.search = {};
            this.search.page_index = 1;
            this.searchForm();
        },
        removeClick(row) {
            this.row_id = row.id;
            this.showDialog = true;
        },
    },
    components: {
        BreadCrumb,
        SimpleFindDialog,
    },
    // components: {
    //     BreadCrumb,
    //     SimplePrint,
    //     simpleFindDialog
    // }
};
</script>

<style lang="scss" scoped>
.table-tip {
    color: red;
    font-size: 12px;
    margin-top: 20px;
}

.operate-con {
    display: flex;

    // justify-content: space-between;
    .operate-flex {
        display: flex;
        margin-left: 1200px;
        margin-top: 10px;
    }
}
</style>
